<style
  lang="less"
  scoped>
  #top-bar {
    height: 85px;
    width: 100%;
    position: relative;
    z-index: 30;
    padding-top: 20px;
    &.withBorderBottom {
      border-bottom: 1px solid #eee;
    }
  }

  .logo {
    float: left;
    width: 150px;
    img {
      height: 42px;
    }
  }

  #location {
    position: relative;
    width: 100px;
    height: 47px;
    top: 6px;
    cursor: default;
    float: left;
    margin-left: 20px;
  }

  #location img {
    position: relative;
    left: 18px;
    top: 8px;
  }

  #location:hover #area.active {
    display: block;
  }

  #location:hover {
    background-color: white;
    border: 1px solid #0097da;
  }

  #location span {
    position: relative;
    left: 25px;
    top: 3px;
  }

  #area {
    position: absolute;
    width: 289px;
    background-color: #fff;
    top: 45px;
    left: -190px;
    border-left: 1px solid #0097da;
    border-right: 1px solid #0097da;
    border-bottom: 1px solid #0097da;
    z-index: 2;
    display: none;
  }

  #area ul p {
    width: 189px;
    height: 0;
    border-top: 1px solid #0097da;
  }

  #area ul li {
    width: 50px;
    float: left;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    color: #818080;
    text-align: center;
    line-height: 30px;
  }

  #area ul li.active {
    background-color: #0ca6ea !important;
    color: white !important;
  }

  #area ul li:hover {
    cursor: pointer;
    color: #0077db;
    background-color: #F4F4F4;
  }

  #header-user-block ul {
    display: inline-block;
    float: right;
    margin-left: 30px;
    li {
      float: left;
      height: 35px;
      line-height: 35px;
      a {
        cursor: pointer;
        padding: 0 12px;
        height: 20px;
        color: #808080;
        &:hover {
          color: #0077db;
        }
      }
    }
  }

  #header-user-block ul :last-child a {
    border-right: none;
  }

  .ci-right {
    top: 13px;
    right: 10px;
    height: 7px;
    overflow: hidden;
    position: absolute;
    display: block;
    font: 400 15px/15px consolas;
    color: #00a7f0;
    transform: rotate(0deg);
    transition: transform .2s ease-in 0s;
  }

  #location:hover .ci-right {
    transform: rotate(180deg);
    transition: transform .2s ease-in 0s;
  }

  s {
    position: relative;
    top: -7px;
    text-decoration: none;
  }

  #header-user-block li img {
    vertical-align: sub;
    margin-right: 10px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .up {
    transition: -webkit-transform .2s ease-in 0s;
    transition: transform .2s ease-in 0s, -webkit-transform .2s ease-in 0s;
    vertical-align: middle !important;
    margin-left: 5px;
  }

  .person_cen {
    position: relative;
  }

  .person_cen:hover .logout {
    display: block;
  }

  .person_cen:hover .up {
    transform: rotate(180deg);
  }

  #header-user-block {
    margin-top: 7px;
  }

  .logout {
    background: #fff url("//v3.cdn.qiyewan.com/border.png") no-repeat;
    width: 103px;
    height: 48px;
    position: absolute;
    top: 29px;
    left: 8px;
    border-bottom: 1px solid #eee;
    display: none;
    a {
      display: block;
      width: 103px;
      height: 48px;
      text-align: center;
      line-height: 54px;
      font-size: 12px;
      &:hover {
        color: #0077db;
      }
    }
  }
</style>

<template>
  <div>
    <div id="top-bar" :class="{'withBorderBottom': withBorderBottom}">
      <div class="container flex">
        <div>
          <div class="logo">
            <router-link to="/">
              <img src="//official.cdn.qiyewan.com/logo.png" style="height: 42px;" title="企业湾" alt="企业湾logo">
            </router-link>
          </div>
          <div id="location" v-on:mouseenter="isShowing = true">

            <img src="../assets/icon_location.png" alt="location">
            <span style="color: #0ca6ea;">{{ getRegion.name }}</span>
            <i class="ci-right">
              <!--<s>◇</s>-->
              <s>◆</s>
            </i>
            <div id="area" v-bind:class="{'active': isShowing}">
              <ul>
                <p></p>
                <li v-for="(item, index) in getRegions"
                    :class="{active: index === getRegionIndex}"
                    @click="changeRegion(item.code)"
                    :title="item.remarks">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <zj-search></zj-search>
        <div id="header-user-block">
          <ul v-if="isLogin">
            <li>
              <router-link to="/cart"><img src="//v3.cdn.qiyewan.com/card.png" alt="cart">购物车</router-link>
            </li>
            <li>
              <router-link to="/order"><img src="//v3.cdn.qiyewan.com/order.png" alt="order">订单</router-link>
            </li>
            <li class="person_cen">
              <router-link to="/person" style="padding-right: 0!important;"><img
                src="//v3.cdn.qiyewan.com/user.png" alt="">个人中心
              </router-link>
              <img src="//v3.cdn.qiyewan.com/tuichu.png" alt="" class="up">
              <div class="logout">
                <a @click="logout" style="margin: 1px 0;text-align: center;">退出登录</a>
              </div>
            </li>
            <!--<li style="width: 20px;">-->
              <!--<div class="jiathis_style" style="margin-bottom: 50px">-->
                <!--<span class="jiathis_txt">分享：</span>-->
                <!--<a href="http://www.jiathis.com/share?uid=2151962" class="jiathis jiathis_txt jiathis_separator jtico jtico_jiathis" target="_blank">更多</a>-->
              <!--</div>-->
            <!--</li>-->
          </ul>
          <ul v-if="!isLogin">
            <li>
              <a :href="`${acctApi}/register?referer=${curPath}`">注册</a>
            </li>
            <li>
              <a :href="`${acctApi}?referer=${curPath}`">登录</a>
            </li>
            <!--<li>-->
            <!--<router-link :to="{ path: '/login', query: {state: '2'} }" style="padding-right: 0!important;">短信登录-->
            <!--</router-link>-->
            <!--</li>-->
            <!--<li v-if="!isLogin"-->
            <!--v-on:click="weixinLogin">-->
            <!--<a>微信登录</a>-->
            <!--</li>-->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  //  import weixin from '../api/weixin'

  let acctApi = process.env.ACCT_API

  export default {
    data () {
      return {
        acctApi: acctApi,

        isShowing: true,
        showFcIntroduce: true,
        keyword: '',
        withBorderBottom: false
      }
    },
    computed: {
      ...mapGetters({
        isLogin: 'isLogin',
        getPhone: 'getPhone',
        getRegions: 'getRegions',
        getRegion: 'getRegion',
        getRegionIndex: 'getRegionIndex',
        cartNum: 'cartNum',
        needLogin: 'needLogin',
        getProducts: 'getProducts',
      }),
      curPath(){
        return window.location.href
      },
      searchProduct(){
        return this.$store.getters.searchProduct(this.keyword) || []
      },
      isResultExist(){
        return this.searchProduct.length > 0
      }
    },
    methods: {
      weixinLogin () {
//        let vm = this
//        weixin.getLoginQrCode(
//          body => {
//            console.log(body)
//          },
//          error => {
//            console.log(error)
//          })
        window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?' +
          'appid=wx51b13533a65272bf' +
          '&redirect_uri=http%3A%2F%2Fwww.qiyewan.com%2F/assets/wx_redirect.htm' +
          '&response_type=code' +
          '&scope=snsapi_login' +
          '&state=WXLOGIN' +
          '#wechat_redirect'
      },
      handleLoginToRegister () {
        this.openRegisterDialog()
      },
      handleLoginToResetPassword () {
        this.openResetPasswordDialog()
      },
      openLoginDialog () {
        this.$refs.loginDialog.openDialog()
      },
      openSmsLoginDialog () {
        this.$refs.smsLoginDialog.openDialog()
      },
      openResetPasswordDialog () {
        this.$refs.resetPasswordDialog.openDialog()
      },
      openRegisterDialog () {
        var storage = window.localStorage
        storage.clear()
        this.$refs.registerDialog.openDialog()
      },

      changeRegion (code) {
        let vm = this
        this.$store.commit('CHANGE_REGION', code)
        this.isShowing = false
        this.$router.replace('/')
        this.$message({
          message: '已经切换到地区：' + vm.getRegion.name,
          type: 'success'
        })
      },
      logout () {
        window.localStorage.clear()
        this.$store.commit('USER_LOGOUT')
        this.$router.replace({name: 'home'})

        window.location.refresh()
//        this.$forceUpdate()
//        window.location.reload(true)
      },
      gotoLoginPage () {
//        this.$router.push({path: '/login', query: {state: '1'}})
        window.location.href = acctApi
      },
      loadJiaThis() {
        let url = '//v3.jiathis.com/code/jia.js?uid=2151962'
        let script = document.createElement('script')
        script.setAttribute('src', url)
        document.getElementsByTagName('head')[0].appendChild(script)
      }
    },
    watch: {
      'needLogin': 'gotoLoginPage',
      $route () {
        let withBorderBottomList = [
          'home',
          'search-result',
          'product-list'
        ]
        this.withBorderBottom = withBorderBottomList.indexOf(this.$route.name) >= 0
        // 检测路由变化
        let pageName = this.$route.name
        if (pageName === 'FcIntroduce') {
          this.showFcIntroduce = false
        }

      }
    },
    created: function () {
      let pageName = this.$route.name
      if (pageName === 'FcIntroduce') {
        this.showFcIntroduce = false
      }
//      this.loadJiaThis()
    },
    mounted() {

    }
  }
</script>



// WEBPACK FOOTER //
// TopBar.vue?538342d8